/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Container,
    Flex,
    Spinner,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Seo from '../../../components/seo'
import {useOptimizelyPage} from '../../../hooks/use-optimizely-page'
import {renderComponentsSwitch} from '../../../components/optimizely/utils/contentRenderer'

const EmptyCart = ({isMiniCart}) => {
    const styles = useMultiStyleConfig('Cart')
    const {data: optimizelyData, isLoading} = useOptimizelyPage('cart-minicart')

    const pageData = optimizelyData?.item || optimizelyData?.page || optimizelyData
    const contentArea = isMiniCart
        ? pageData?.EmptyMinicartContent
        : pageData?.EmptyCartContent

    return (
        <Box data-testid="sf-cart-empty" {...styles.emptyCartRoot}>
            <Seo title="My Shopping Bag" description="My Shopping Bag" noIndex noFollow />
            <Container
                {...styles.emptyCartContainer}
                px={isMiniCart ? 0 : [4, 6, 6, 4]}
                paddingTop={{base: 8, lg: isMiniCart ? 0 : 8}}
            >
                {isLoading ? (
                    <Flex justify="center" align="center" py={8}>
                        <Spinner />
                    </Flex>
                ) : (
                    contentArea?.map((item) => {
                        const block = item?.ContentLink?.Expanded
                        if (!block) return null
                        return (
                            <Box key={item.ContentLink.GuidValue}>
                                {renderComponentsSwitch(block)}
                            </Box>
                        )
                    })
                )}
            </Container>
        </Box>
    )
}

EmptyCart.propTypes = {
    isMiniCart: PropTypes.bool
}

export default EmptyCart
